import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { min, take } from 'rxjs/operators';
import cpfVerdadeiro from '../../funcoes/validar.cpf';
import cnpjVerdadeiro from '../../funcoes/validar.cnpj';
import telefoneVerdadeiro from '../../funcoes/validar.telefone';
import { ClienteFisicoElement, ClienteJuridicoElement, ClienteRuralElement } from '../../interfaces/cliente';
import { AngularFireAuth } from "@angular/fire/auth";
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import * as firebase from 'firebase';
import { ProdutosDescontoPersonalizadoDialog } from '../dialogs/produtos-desconto-personalizado-dialog/produtos-desconto-personalizado-dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-novo-cliente',
  templateUrl: './novo-cliente.component.html',
  styleUrls: ['./novo-cliente.component.scss', '../../styles/estilo.padrao.scss']
})
export class NovoClienteComponent implements OnInit {
  uid;
  clienteForm: FormGroup;
  produtosDescontoSource;
  gruposPromocionais = [];
  displayedColumns: string[] = ['Nome', 'Produtos', 'QuantidadeMinima', 'PorcentagemDesconto', 'Remover'];

  vendedores: any[] = [];
  bPermissaoCadastrar: boolean = false;
  bErroLatLng: boolean = false;

  aComplementosEmail: any = ['@gmail', '@hotmail', '@outlook', '@yahoo', '@icloud', '@bol']
  aFinalEmail: any = ['.com', '.com.br']

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private af: AngularFireAuth,
    private dialog: MatDialog,
  ) {
    this.uid = localStorage.getItem('uid');

    //Validar Permissões
    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.usuarioService.getFuncionario(this.uid).subscribe(dados => {
          if (dados) {
            const dadosFuncionario: any = dados;
            this.bPermissaoCadastrar = dadosFuncionario.Permissoes.Cadastrar.Clientes;
          }
        });
      } else
        this.bPermissaoCadastrar = true;
    });
  }

  //Máscaras
  maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskCEP = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
  maskCNPJ = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/];
  maskCPF = [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];

  ngOnInit(): void {
    this.clienteForm = this.formBuilder.group({
      tipoCadastro: ['pessoaFisica', [Validators.required]],
      credito: [1000, [Validators.required, Validators.min(1), Validators.max(2000000)]],
      bCompraCheque: [false, [Validators.required]],
      bCompraBoleto: [false, [Validators.required]],
      bCompraNota: [false, [Validators.required]],
      nome: ['', [Validators.required]],
      cpf: ['', [Validators.required, cpfVerdadeiro]],
      telefone: ['', [Validators.required, telefoneVerdadeiro]],
      telefoneSecundario: ['', null],
      cep: ['', [Validators.required]],
      logradouro: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      complemento: ['', null],
      bairro: ['', [Validators.required]],
      cidade: ['', [Validators.required]],
      uf: ['', [Validators.required]],
      referencia: ['', null],
      // email: ['', [Validators.required, Validators.email]],
      email: ['', [Validators.required]],
      senha: ['', null],
      //Empresa
      cnpj: ['', null],
      razaoSocial: ['', null],
      inscricaoEstadual: ['', null],
      vendedor: ['', null],
      idVendedor: ['', null],
      responsavelCompra: ['', null],
      latitude: ['', [Validators.required]],
      longitude: ['', [Validators.required]],
      sComplementoEmail: ['', [Validators.required]],
      sFinalEmail: ['', [Validators.required]],
      prazoNota: [15, [Validators.required, Validators.min(1)]],
    });

    this.clienteForm.get('latitude').disable();
    this.clienteForm.get('longitude').disable();

    //Recupera os funcionários / Vendedores
    this.usuarioService.getFuncionarios(this.uid).pipe(take(1)).subscribe(snap => {
      this.vendedores = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.Status && dados.Permissoes.Vender) {
            this.vendedores.push({
              value: item.key,
              name: dados.Nome,
            });
          }
        });

        //Ordena alfabeticamente
        this.vendedores.sort((a, b) => a.value.localeCompare(b.value));

        if (this.uid !== environment.idCliente) {
          this.clienteForm.get('idVendedor').patchValue(this.uid);
          this.clienteForm.get('idVendedor').disable();
          this.clienteForm.get('credito').disable();
          this.clienteForm.get('bCompraCheque').disable();
          this.clienteForm.get('bCompraBoleto').disable();
          this.clienteForm.get('bCompraNota').disable();
        }
      }
    });
  }

  onChangeTipoCadastro() {
    switch (this.f.tipoCadastro.value) {
      case 'pessoaFisica':
        this.clienteForm.get('cpf').setValidators([Validators.required, cpfVerdadeiro]);

        this.clienteForm.get('cnpj').setErrors(null);
        this.clienteForm.get('razaoSocial').setErrors(null);
        this.clienteForm.get('inscricaoEstadual').setErrors(null);
        break;

      case 'pessoaJuridica':
        this.clienteForm.get('cpf').setErrors(null);

        this.clienteForm.get('cnpj').setValidators([Validators.required, cnpjVerdadeiro]);
        this.clienteForm.get('razaoSocial').setValidators([Validators.required]);
        this.clienteForm.get('inscricaoEstadual').setValidators([Validators.required]);
        break;

      case 'produtorRural':
        this.clienteForm.get('cpf').setValidators([Validators.required, cpfVerdadeiro]);
        this.clienteForm.get('inscricaoEstadual').setValidators([Validators.required]);

        this.clienteForm.get('cnpj').setErrors(null);
        this.clienteForm.get('razaoSocial').setErrors(null);
        break;
    }
  }

  cadastrar() {

    if (this.bPermissaoCadastrar) {
      this.spinner.show('default');

      if (this.clienteForm.valid) {
        // if (this.sComplementoEmail && this.sFinalEmail) {
        switch (this.f.tipoCadastro.value) {
          case 'pessoaFisica':
            this.cadastrarPessoaFisica();
            break;

          case 'pessoaJuridica':
            this.cadastrarPessoaJuridica();
            break;

          case 'produtorRural':
            if (this.f.inscricaoEstadual.value.toLowerCase() !== 'isento') {
              this.cadastrarProdutorRural();
            } else {
              this.toastr.error('A Inscrição Estadual não pode ser isenta!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
              this.clienteForm.markAllAsTouched();
              setTimeout(() => this.spinner.hide('default'), 500);
            }
            break;
        }
        // } else {
        //   this.toastr.error('Informe o complemento do E-mail!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
        //   this.clienteForm.markAllAsTouched();
        //   setTimeout(() => this.spinner.hide('default'), 500);
        // }

      } else {
        this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
        this.clienteForm.markAllAsTouched();
        setTimeout(() => this.spinner.hide('default'), 500);
      }
    } else {
      this.toastr.error('Você não possui permissão para cadastrar usuários', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  cadastrarPessoaFisica() {
    this.usuarioService.getClienteCPF(this.f.cpf.value, this.uid).pipe(take(1)).subscribe(async snap => {
      if (snap.length === 0) {
        const map: ClienteFisicoElement = {
          Status: true,
          CompraViaCheque: this.f.bCompraCheque.value,
          CompraViaBoleto: this.f.bCompraBoleto.value,
          CompraViaNota: this.f.bCompraNota.value,
          Nome: this.f.nome.value.trim(),
          CPF: this.f.cpf.value.trim(),
          Telefone: this.f.telefone.value.trim(),
          TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
          TimestampCadastro: firebase.default.database.ServerValue.TIMESTAMP,
          Email: this.f.email.value + this.f.sComplementoEmail.value + this.f.sFinalEmail.value,
          CEP: this.f.cep.value.trim(),
          Logradouro: this.f.logradouro.value.trim(),
          Numero: this.f.numero.value.trim(),
          Complemento: this.f.complemento.value.trim(),
          Bairro: this.f.bairro.value.trim(),
          Cidade: this.f.cidade.value.trim(),
          UF: this.f.uf.value.trim(),
          Referencia: this.f.referencia.value.trim(),
          Credito: this.f.credito.value,
          CreditoDisponivel: this.f.credito.value,
          Tipo: 'pessoaFisica',
          IDVendedor: this.f.idVendedor.value,
          ResponsavelCompra: this.f.responsavelCompra.value.trim(),
          GruposPromocionais: this.gruposPromocionais,
          Latitude: this.f.latitude.value ? this.f.latitude.value : false,
          Longitude: this.f.latitude.value ? this.f.longitude.value : false,
          PrazoNota: this.f.prazoNota.value,
        }

        try {
          const senha = this.f.cpf.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');

          const resp = await this.usuarioService.setCliente(map, this.uid, this.f.email.value + this.f.sComplementoEmail.value + this.f.sFinalEmail.value, senha);
          setTimeout(() => {
            this.spinner.hide('default');
            if (resp.Status) {
              this.usuarioService.setLog("Cadastro de novo Cliente pessoa física: " + this.f.nome.value.trim() + ' CPF: ' + this.f.cpf.value.trim(), map, this.uid);

              setTimeout(() => {
                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                  this.router.navigate(["/pages/consultar-cliente"], { queryParams: { IDCliente: resp.IDCliente } }));
              }, 2000);
            } else {
              this.toastr.error('Erro ao cadastrar Cliente! ' + resp.Mensagem, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/novo-cliente"]));
            }
          }, 1500);
        } catch (e) {
          console.log(e)
          this.spinner.hide('default');

          this.usuarioService.setLog("Erro no cadastro de novo Cliente: " + this.f.nome.value.trim() + ' CPF: ' + this.f.cpf.value.trim() + '; Erro: ' + e, map, this.uid);

          this.toastr.error('Erro ao cadastrar Cliente!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
          this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/pages/novo-cliente"]));
        }

      } else {
        this.spinner.hide('default');
        this.toastr.error('Este CPF já consta no sistema!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      }
    });
  }

  cadastrarPessoaJuridica() {
    this.usuarioService.getClienteCNPJ(this.f.cnpj.value, this.uid).pipe(take(1)).subscribe(async snap => {
      if (snap.length === 0) {
        const map: ClienteJuridicoElement = {
          Status: true,
          CompraViaCheque: this.f.bCompraCheque.value,
          CompraViaBoleto: this.f.bCompraBoleto.value,
          CompraViaNota: this.f.bCompraNota.value,
          Nome: this.f.nome.value.trim(),
          Telefone: this.f.telefone.value.trim(),
          TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
          TimestampCadastro: firebase.default.database.ServerValue.TIMESTAMP,
          Email: this.f.email.value + this.f.sComplementoEmail.value + this.f.sFinalEmail.value,
          CNPJ: this.f.cnpj.value,
          RazaoSocial: this.f.razaoSocial.value,
          InscricaoEstadual: this.f.inscricaoEstadual.value,
          CEP: this.f.cep.value.trim(),
          Logradouro: this.f.logradouro.value.trim(),
          Numero: this.f.numero.value.trim(),
          Complemento: this.f.complemento.value.trim(),
          Bairro: this.f.bairro.value.trim(),
          Cidade: this.f.cidade.value.trim(),
          UF: this.f.uf.value.trim(),
          Referencia: this.f.referencia.value.trim(),
          Credito: this.f.credito.value,
          CreditoDisponivel: this.f.credito.value,
          Tipo: 'pessoaJuridica',
          IDVendedor: this.f.idVendedor.value,
          ResponsavelCompra: this.f.responsavelCompra.value.trim(),
          GruposPromocionais: this.gruposPromocionais,
          Latitude: this.f.latitude.value ? this.f.latitude.value : false,
          Longitude: this.f.latitude.value ? this.f.longitude.value : false,
          PrazoNota: this.f.prazoNota.value,
        }

        try {

          const senha = this.f.cnpj.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
          const resp = await this.usuarioService.setCliente(map, this.uid, this.f.email.value + this.f.sComplementoEmail.value + this.f.sFinalEmail.value, senha);
          setTimeout(() => {
            this.spinner.hide('default');
            if (resp.Status) {
              this.usuarioService.setLog("Cadastro de novo Cliente pessoa jurídica: " + this.f.nome.value.trim() + ' CNPJ: ' + this.f.cnpj.value.trim(), map, this.uid);

              setTimeout(() => {
                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                  this.router.navigate(["/pages/consultar-cliente"], { queryParams: { IDCliente: resp.IDCliente } }));
              }, 2000);
            } else {
              this.toastr.error('Erro ao cadastrar Cliente! ' + resp.Mensagem, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/novo-cliente"]));
            }
          }, 1500);
        } catch (e) {
          console.log(e)
          this.spinner.hide('default');

          this.usuarioService.setLog("Erro no cadastro de novo Cliente: " + this.f.nome.value.trim() + ' CNPJ: ' + this.f.cpf.value.trim() + '; Erro: ' + e, map, this.uid);

          this.toastr.error('Erro ao cadastrar Cliente!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
          this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/pages/novo-cliente"]));
        }

      } else {
        this.spinner.hide('default');
        this.toastr.error('Este CNPJ já consta no sistema!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      }
    });
  }

  cadastrarProdutorRural() {
    this.usuarioService.getClienteIE(this.f.inscricaoEstadual.value, this.uid).pipe(take(1)).subscribe(async snap => {
      if (snap.length === 0) {
        const map: ClienteRuralElement = {
          Status: true,
          CompraViaCheque: this.f.bCompraCheque.value,
          CompraViaBoleto: this.f.bCompraBoleto.value,
          CompraViaNota: this.f.bCompraNota.value,
          Nome: this.f.nome.value.trim(),
          CPF: this.f.cpf.value,
          Telefone: this.f.telefone.value.trim(),
          TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
          TimestampCadastro: firebase.default.database.ServerValue.TIMESTAMP,
          InscricaoEstadual: this.f.inscricaoEstadual.value,
          Email: this.f.email.value + this.f.sComplementoEmail.value + this.f.sFinalEmail.value,
          CEP: this.f.cep.value.trim(),
          Logradouro: this.f.logradouro.value.trim(),
          Numero: this.f.numero.value.trim(),
          Complemento: this.f.complemento.value.trim(),
          Bairro: this.f.bairro.value.trim(),
          Cidade: this.f.cidade.value.trim(),
          UF: this.f.uf.value.trim(),
          Referencia: this.f.referencia.value.trim(),
          Credito: this.f.credito.value,
          CreditoDisponivel: this.f.credito.value,
          Tipo: 'produtorRural',
          IDVendedor: this.f.idVendedor.value,
          ResponsavelCompra: this.f.responsavelCompra.value.trim(),
          GruposPromocionais: this.gruposPromocionais,
          Latitude: this.f.latitude.value ? this.f.latitude.value : false,
          Longitude: this.f.latitude.value ? this.f.longitude.value : false,
          PrazoNota: this.f.prazoNota.value,
        }

        try {

          const senha = this.f.cpf.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
          const resp = await this.usuarioService.setCliente(map, this.uid, this.f.email.value + this.f.sComplementoEmail.value + this.f.sFinalEmail.value, senha);
          setTimeout(() => {
            this.spinner.hide('default');
            if (resp.Status) {
              this.usuarioService.setLog("Cadastro de novo Cliente produtor rural: " + this.f.nome.value.trim() + ' Inscrição Estadual: ' + this.f.inscricaoEstadual.value.trim(), map, this.uid);

              setTimeout(() => {
                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                  this.router.navigate(["/pages/consultar-cliente"], { queryParams: { IDCliente: resp.IDCliente } }));
              }, 2000);
            } else {
              this.toastr.error('Erro ao cadastrar Cliente! ' + resp.Mensagem, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/novo-cliente"]));
            }
          }, 1500);
        } catch (e) {
          console.log(e)
          this.spinner.hide('default');

          this.usuarioService.setLog("Erro no cadastro de novo Cliente: " + this.f.nome.value.trim() + ' Inscrição Estadual: ' + this.f.inscricaoEstadual.value.trim() + '; Erro: ' + e, map, this.uid);

          this.toastr.error('Erro ao cadastrar Cliente!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
          this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/pages/novo-cliente"]));
        }

      } else {
        this.spinner.hide('default');
        this.toastr.error('Esta Incrição Estadual já consta no sistema!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      }
    });
  }

  removerDescontoProduto(produto) {
    const index = this.gruposPromocionais.findIndex(x => x.IDGrupoDesconto === produto.IDGrupoDesconto);

    if (index !== -1) {
      const aux = this.gruposPromocionais.filter(item => item.IDGrupoDesconto !== produto.IDGrupoDesconto);
      this.gruposPromocionais = aux;
      this.produtosDescontoSource = new MatTableDataSource(this.gruposPromocionais);
    }
  }

  adicionarProdutoDesconto() {
    if (this.uid === environment.idCliente) {
      const dialogRef = this.dialog.open(ProdutosDescontoPersonalizadoDialog);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {

          // Verificar se não há produtos relacionados com outra promoção.
          const index = this.gruposPromocionais.findIndex(x => x.IDGrupoDesconto === result.IDGrupoDesconto);
          if (index === -1) {

            let auxIDProdutos = [];
            let bPossuiProdutoEmOutraPromocao = false;

            for (let i = 0; i < this.gruposPromocionais.length; i++) {
              for (let j = 0; j < this.gruposPromocionais[i].Produtos.length; j++) {
                auxIDProdutos.push(this.gruposPromocionais[i].Produtos[j].ID)
                for (let k = 0; k < result.Produtos.length; k++) {
                  auxIDProdutos.includes(result.Produtos[k].ID) ? bPossuiProdutoEmOutraPromocao = true : null;
                }
              }
            }

            if (!bPossuiProdutoEmOutraPromocao) {
              this.gruposPromocionais.push({
                IDGrupoDesconto: result.IDGrupoDesconto, Nome: result.Nome, QuantidadeMinima: result.QuantidadeMinima, PorcentagemDesconto: (result.PorcentagemDesconto / 100), Produtos: result.Produtos, ProdutosString: result.ProdutosString
              });
              this.produtosDescontoSource = new MatTableDataSource(this.gruposPromocionais);
            } else
              this.toastr.error("Há um ou mais produtos em conflito com outra promoção para o mesmo cliente", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

          } else
            this.toastr.warning("Este grupo já está adicionado", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        }
      });
    } else {
      this.toastr.error("Você não pode adicionar grupos de desconto à clientes", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  onChangeTel(e, b) {
    if (e.length >= 6) {
      if (e.substring(5, 6) === '9') {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    } else {
      b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
  }

  async buscarCEP() {
    if (this.f.cep.value.length == 10) {
      const resp: any = await this.usuarioService.getBuscaCEP(this.f.cep.value);
      const dados = resp;

      if (dados.erro) {
        this.toastr.warning("Cep inválido!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.clienteForm.get('logradouro').patchValue('');
        this.clienteForm.get('complemento').patchValue('');
        this.clienteForm.get('bairro').patchValue('');
        this.clienteForm.get('cidade').patchValue('');
        this.clienteForm.get('uf').patchValue('');
        this.clienteForm.get('cidade').enable();
        this.clienteForm.get('uf').enable();
      } else {
        this.clienteForm.get('logradouro').patchValue(dados.logradouro);
        this.clienteForm.get('complemento').patchValue(dados.complemento);
        this.clienteForm.get('bairro').patchValue(dados.bairro);
        this.clienteForm.get('cidade').patchValue(dados.localidade);
        this.clienteForm.get('uf').patchValue(dados.uf);
        this.clienteForm.get('cidade').disable();
        this.clienteForm.get('uf').disable();
        this.buscarLatLng();
      }
    }
  }

  async buscarLatLng() {
    if (this.f.logradouro.value.length > 0 && this.f.cidade.value.length > 0) {
      try {
        const aux: any = await this.usuarioService.getLatLng(this.f.logradouro.value + this.f.bairro.value + this.f.cidade.value + '/' + this.f.uf.value);

        const dadosLatLng = aux.results[0].geometry.location;
        this.clienteForm.get('latitude').patchValue(dadosLatLng.lat);
        this.clienteForm.get('longitude').patchValue(dadosLatLng.lng);
      }
      catch (err) {
        this.clienteForm.get('latitude').patchValue(false);
        this.clienteForm.get('longitude').patchValue(false);
        this.bErroLatLng = true;
        this.toastr.warning('Não foi possível localizar a latitude e longitude, o gestor deve adicionar manualmente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });

        if (this.uid === environment.idCliente) {
          this.clienteForm.get('latitude').enable();
          this.clienteForm.get('longitude').enable();
        }
      };
    } else {
      this.bErroLatLng = true;
      this.toastr.error("Preencha o endereço antes para verificar a latitude e longitude!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/novo-cliente"]));
  }

  upperCase(event) {
    const ufUpperCase = (event.target as HTMLInputElement).value.toUpperCase();
    this.clienteForm.get('uf').patchValue(ufUpperCase);
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;

    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44 || k == 47) {
      return true;
    } else {
      return false;
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.clienteForm.controls; }

}
